// extracted by mini-css-extract-plugin
module.exports = {"title":"disabled-app_title_391ue"};